var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame129(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 28,
    fill: "#DDE4E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 25C21 18.9249 25.9249 14 32 14C38.0751 14 43 18.9249 43 25C43 31.0751 38.0751 36 32 36C25.9249 36 21 31.0751 21 25Z",
    fill: "#808485"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 43C19.2 43 8.33333 48.6667 4.5 51.5C11.3 61.5 23 64 28 64H36C48.8 64 57 55.6667 59.5 51.5C55.6667 48.6667 44.8 43 32 43Z",
    fill: "#808485"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame129);
export default __webpack_public_path__ + "static/media/Frame 129.e97410a355c1cfeebaf8e38c277c7d14.svg";
export { ForwardRef as ReactComponent };